<template>
  <div class="membership_manage_term_setting_modal_textarea_width">
    <v-dialog v-model="membershipTermSettingModal" max-width="1000">
      <v-card
        class="overflow-y-auto overflow-x-auto membership_manage_term_setting_modal_textarea_width"
      >
        <v-card-title class="coggiri-middle-subject pt-5 pl-5 pb-5 float-left"
          >유료 멤버십 상품 약관 설정</v-card-title
        >

        <v-btn
          small
          class="font-weight-black mt-5 mr-5 mb-5 float-right"
          aling="right"
          right
          @click="sampleTermsApplication(param)"
          >표본약관(예시) 적용</v-btn
        >

        <v-textarea
          v-model="text"
          outlined
          hide-details
          class="pl-5 pr-5 col-5 black--text overflow-y-auto"
          height="600"
          no-resize
        ></v-textarea>

        <v-btn
          color="black"
          hide-details
          depressed
          class="ml-5 mt-5 mb-5 white--text"
          @click="membershipTermSettingModal = false"
          width="475"
          >닫기</v-btn
        >

        <v-btn
          color="primary"
          hide-details
          class="white--text ml-2 mt-5 mb-5 pl-4 pr-4"
          depressed
          width="475"
          @click="save()"
          >저장하기</v-btn
        >
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import M from "@/libs/mapping.js";

export default {
  data: () => {
    return {
      membershipTermSettingModal: false,
      text: "",
      sample_text: `제 1 조 [목적]
본 약관은 00 쇼핑몰(이하 “회사”라고 합니다)가 운영하는 웹사이트, 모바일 웹 및 앱 등에서 제공하는 유료 멤버십 서비스를 이용하는 멤버십 회원과 회사 간의 권리·의무 관계, 관련 절차 및 기타 제반사항을 정하는 것을 목적으로 합니다.

제 2 조 [용어의 정의]
(1) 본 약관에서 사용하는 용어의 정의는 다음과 같습니다.
1. 유료 멤버십 서비스(이하 “본 서비스”라고 합니다)란, 회사가 멤버십 회원에게 제공하고자 본 약관에서 규정하고 있는 각종 혜택 및 관련 부가서비스 일체를 의미하며, 본 서비스는 월/연/특정기간 단위로 가입 및 이용할 수 있습니다.
2. “회원”이란 쇼핑몰 이용약관에 동의하고 쇼핑몰 회원으로 가입함으로써 본 서비스에 가입 신청을 할 수 있는 고객을 의미합니다.
3. “멤버십 회원”이란 회원 중 본 약관 및 이용료 결제에 동의하고 이용신청 절차를 거쳐 본 서비스에 가입한 회원을 의미합니다.
4. “혜택”이란 멤버십 회원에게 제공되는 적립,할인,배송,쿠폰,전용 상품등의 혜택을 의미합니다.
5. “무료 체험 기간”이란, 회사가 멤버십 회원에게 본 서비스 가입 시 시혜적으로 부여할 수 있는 본 서비스의 무상 이용 기간을 의미합니다.
6. “이용료”란 본 서비스에 가입하여 본 서비스를 이용하고자 하는 회원이 회사에 지불하는 금액을 의미합니다. 단, 업그레이드 상품을 위한 추가적인 비용 결제는 포함되지 않습니다.
7. “정기 결제”란 멤버십 회원이 본 서비스를 매월 또는 일정 시기에 반복적으로 거래하기 위하여 미리 입력·등록한 결제수단 또는 결제정보로 매월 또는 일정 시기에 자동으로 결제하는 서비스를 의미합니다.
(2) 본 약관에서 사용되는 용어의 정의는 본 약관에서 별도로 규정하는 경우를 제외하고 「전자상거래 등에서의 소비자 보호에 관한 법률」, 「문화산업진흥 기본법」 등 관계 법령 및 쇼핑몰 이용약관에서 규정하고 있는 정의를 따릅니다.

제 3 조 [약관의 게시와 개정]
(1) 회사는 본 약관 전부를 회원이 확인할 수 있도록 쇼핑몰 MY 페이지 등 회사가 운영하는 웹사이트, 모바일 웹 및 앱 등을 통해 게시하는 등 기술적 조치를 취합니다.
(2) 회사는 「약관의 규제에 관한 법률」, 「전자상거래 등에서의 소비자 보호에 관한 법률」 등 관련 법률에 위배되지 않는 범위 내에서 약관을 개정할 수 있습니다.
(3) 회사가 약관을 개정하는 경우에는 적용일자 및 개정사유를 명시하여 쇼핑몰 유료 멤버십 MY 페이지 등에 그 개정약관의 적용일자 7일전부터 적용일자 전일까지 공지합니다. 다만, 멤버십 회원에게 불리한 약관의 개정의 경우에는 적용일자 30일 전부터 적용일자 전일까지 공지하며, 공지 외에 회원의 전자우편, 전자쪽지, 로그인시 동의창 등의 전자적 수단을 통해 따로 명확히 통지합니다. 개정약관은 적용일자 이전으로 소급하여 적용되지 아니합니다.
(4) 회사가 전항에 따라 개정약관을 공지 또는 통지하면서 회원에게 전항의 공지기간 내에 의사표시를 하지 않으면 의사표시가 표명된 것으로 본다는 뜻을 명확하게 공지 또는 통지하였음에도 회원이 명시적으로 거부의 의사표시를 하지 아니한 경우 회원이 개정약관에 동의한 것으로 봅니다.
(5) 멤버십 회원은 개정, 변경된 약관의 내용에 동의하지 않을 경우 본 약관 제8조에 따라 본서비스 이용 해지를 요청할 수 있습니다.

제 4 조 [이용계약의 성립 등]
(1) “이용계약”은 본 서비스를 이용하고자 하는 회원이 본 약관에 동의한 뒤 결제 수단을 선택하고 결제 정보를 입력하는 등 이용신청 절차를 거쳐 이용신청을 완료하고, 회사가 회원의 이용신청을 승낙함으로써 성립합니다. 이용계약의 성립시기는 회사가 이용신청에 대한 승낙의 의사를 표시한 시점으로 합니다.
(2) 회사는 회원의 이용신청이 다음 각 호에 해당하는 경우에는 승낙하지 아니하거나 승낙을 유보할 수 있으며, 승낙 이후에도 아래 1호 내지 4호의 사유가 확인된 경우에는 승인을 취소하고 이용계약을 해제할 수 있습니다.
1. 회원 본인 명의로 이미 서비스에 가입중인 경우
2. 실명이 아니거나 타인의 정보를 이용한 경우
3. 허위의 정보를 기재하거나, 회사가 제시하는 내용을 기재하지 않은 경우
4. 만 14세 미만의 미성년자인 경우
5. 기타 본 약관에 위배되거나 위법 또는 부당한 이용신청 등 이용신청을 승낙하지 아니할 합리적인 사유가 있다고 회사가 판단하는 경우
6. 서비스 관련 설비의 여유가 없거나, 기술상 또는 업무상 문제가 있는 경우

제 5 조 [결제수단 및 결제일자 등]
(1) 멤버십 회원은 결제 수단 및 결제 정보를 입력하고 이용료 및 업그레이드 상품 이용료를 결제하여야 하며, 이용료 및 업그레이드 상품 이용료는 월 단위 또는 연 단위로 정기 결제 또는 매월 또는 특정기간동안 1회 결제가 가능합니다.
(2) 정기 결제의 경우 멤버십 회원이 가장 마지막으로 등록한 결제 수단으로 본 서비스의 정기 결제가 이루어집니다.
(3) 정기 결제일은 멤버십 회원이 본 서비스에 최초 가입한 날에 해당하는 일자로 자동 설정됩니다. 만약 특정 월에 결제일이 존재하지 않는 경우, 해당 월에 한하여 말일에 결제됩니다(예를 들어, 1월 31일 가입자의 정기 결제일은 2월 28일, 3월 31일, 4월 30일 등).
(4) 회사는 결제가 이루어지면 회원에게 결제 내용을 전화, 팩스, 제4조 제1항의 통지수단 등 전자적 매체나 방식을 이용하여 통지합니다. 단, 멤버십 회원의 명시적인 동의가 있는 경우에는 위 통지를 생략할 수 있습니다.
(5) 멤버십 회원이 등록한 결제정보가 어떠한 사유로든 유효하지 않게 되어 정상적으로 결제가 이루어지지 아니하고, 회사가 멤버십 회원에게 제4조 제1항의 통지수단으로 통지하는 재결제기한까지 결제정보가 정상화되지 않는 경우 재결제 실패 익일 이용계약이 자동으로 해지됩니다.

제 7 조 [청약철회, 해지 및 환불]
(1) 본 서비스는 이용료 결제 후 어떠한 혜택도 사용하지 않은 경우 청약철회가 가능합니다.
(2) 멤버십 회원이 이용료 결제 후 할인,적립,쿠폰등 혜택를 이용한 경우에는 청약철회, 해지 및 환불이 불가능합니다.
(3) 회사는 회원의 환불 시점에 지급된 쿠폰과 적립금을 즉시 회수할 수 있습니다.
(4) 청약철회 또는 이용계약의 해지로 인한 환불 시점을 기준으로 유료 멤버십 서비스를 통해 적립 받을 예정에 있지만 아직 적립되지 아니한적립금이 있는 경우, 본조 제1항에 따른 청약철회 또는 즉시 환불 발생 시, 적립예정 적립금은 적립되지 않습니다.

제 8 조 [이용계약 및 정기 결제의 해지 등]
(1) 멤버십 회원은 회사에게 통지함으로써 청약철회 또는 이용계약의 해지를 요청할 수 있습니다.
(2) 멤버십 회원에 의한 청약철회 또는 이용계약 해지가 회사에 통지될 경우, (i) 제7조 제1항에 따라 청약철회가 가능한 멤버십 회원은 청약철회 및 환불과 동시에 이용계약이 종료되며, (ii) 제 7조 제2항에 따라 이용기간 내 해지가 가능한 멤버십 회원은 해지 및 환불과 동시에 이용계약이 종료됩니다.  단, 제7조 제2항에 따라 이용 기간 내 해지가 불가능한 고객은 정기 결제가 해지되고, 이용계약 해지의 효과는 마지막으로 결제한 이용료에 해당하는 이용기간이 종료된 직후 발생합니다.
(3) 본조 제2항 단서에 따라 정기 결제를 해지한 멤버십 회원은 마지막으로 결제한 이용료에 해당하는 이용 기간 동안은 이용이 가능하며, 다음 결제일(익월)부터 이용료가 결제되지 않습니다.
(4) 멤버십 회원은 본조 제2항 단서에 따라 정기 결제를 해지한 시점으로부터 현재 이용중인 본 서비스 이용기간 종료일 전일까지 해지를 취소할 수 있습니다.
(5) 멤버십 이용계약이 청약철회되거나 해지되면, 멤버십 회원이 사용하지 않은 쿠폰 또는 적립금등 할인 관련 혜택은 소멸되며, 재가입에도 불구하고 쿠폰이나 적립금등 할인 혜택은 복구되지 않습니다.

제 9 조 [금지행위 및 이용제한 등]
(1) 회사는 멤버십 회원이 다음 각호의 금지행위 또는 쇼핑몰 멤버십 이용약관에서 정한 금지행위를 하였을 경우, 사전통지 없이 이용계약을 해제, 해지하거나 또는 기간을 정하여 본 서비스의 이용을 제한할 수 있으며, 해당 멤버십 회원은 본 서비스 재가입 및 이용신청이 제한됩니다.
1. 본 약관에 따른 권리, 의무의 전부 또는 일부를 타인에게 대여, 양도, 위임하는 행위
2. 타인의 명의를 도용하거나 타인의 결제 정보를 사용하여 본 서비스를 이용하는 행위
3. 본 서비스의 정상적인 운영 또는 다른 회원의 본 서비스 이용을 방해하는 행위
4. 본 서비스를 불법적인 목적이나 본 약관에 따른 목적 외의 부당한 목적으로 활용하는 행위
(2) 제1항의 해제, 해지는 회사가 정한 통지방법에 따라 멤버십 회원에게 그 의사를 표시한 때에 효력이 발생합니다.
(3) 회사의 해제, 해지 및 이용제한에 대하여 멤버십 회원은 회사가 정한 절차에 따라 이의신청을 할 수 있습니다. 이 때 이의가 정당하다고 회사가 인정하는 경우, 회사는 즉시 서비스의 이용을 재개합니다.
(4) 제1항의 사유로 환불이 필요할 경우 회사는 회원이 본 서비스의 이용료를 결제한 수단과 같은 결제수단으로 환불하며, 이 경우 본 서비스의 이용료에서 멤버십 회원이 본 서비스 이용으로 받은 이익을 공제한 후 환불합니다. 이익을 공제하는 자세한 사항은 회사의 운영 정책에 따릅니다.

제 10 조 [회사의 권리와 의무]
(1) 회사는 회원이 안정적으로 서비스를 이용할 수 있도록 성실하게 서비스를 제공합니다.
(2) 회사는 회사가 제공하는 서비스와 관련한 일체에 대하여 권한을 가집니다.
(3) 인터넷 환경의 특성 상 인터넷의 불완전성 또는 하드웨어의 불량, 시스템다운 등으로 인하여 서비스 이용과 관련하여 발생한 거래내역 등 저장된 회원의 데이터가 전부 또는 일부 손실될 수 있으며, 이런 경우 회사는 고의 또는 과실로 회원의 데이터를 손실한 경우를 제외하고는 이와 관련한 책임을 부담하지 아니합니다.
(4) 회사는 민·형사상 법적 절차에 의해 법원 등으로부터 명령을 통지 받거나 관계법령에 의한 유관기관의 요구가 있는 경우 서비스의 이용을 제한하거나 관련 정보 등을 제공할 수 있습니다.

제 11 조 [멤버십 회원의 의무]
(1) 회원은 회사가 제공하는 서비스에 대하여 서비스 별 이용 조건에 따른 이용권한을 가집니다.
(2) 회원은 서비스를 이용하여 이 약관 및 관련 법령, 지침 등을 위반하거나 선량한 풍속, 기타 사회질서에 반하는 행위를 하여서는 아니됩니다.
(3) 회원은 회사에 등록한 자신의 정보를 최신의 정보로 유지하여야 합니다. 만일, 이를 다하지 아니하여 물품의 배송 또는 회사의 통지(청구서, 사전통지 등)가 수신되지 아니한 경우 그로 인하여 발생하는 문제에 대해 회사는 책임을 부담하지 아니합니다.
(4) 회원은 서비스 접속정보에 관한 관리책임이 있으며, 회원의 주의의무위반으로 인하여 타인에 의한 정보의 도용 및 부정이용이 발생한 경우 그에 따른 책임을 부담합니다.
(5) 회원은 회사의 사전 서면 동의 없이 서비스이용과 관련한 권리를 타인에게 양도하거나 제공하지 아니합니다.
(6) 회원은 침해사고 예방을 위하여 자신이 이용하는 시스템 등에 대한 적절한 보안조치를 취하여야 하며, 회사가 보안관련 정보를 제공하는 경우 회사의 지시에 따라 성실히 조치를 이행하여야 합니다.
(7) 회원은 이 약관, 이용안내, 서비스와 관련하여 통지 받은 제반 사항을 확인하고, 이와 관련한 사항을 준수하여야 합니다.

제 12 조 [무료 체험 기간 등]
(1) 회사는 일정한 기간을 정하여 멤버십 회원에게 무료 체험 기간을 제공할 수 있습니다. 무료 체험 기간이 만료된 이후, 멤버십 회원이 등록한 결제 정보를 이용하여 회사에 이용료를 결제한 멤버십 회원에 한하여 본 서비스가 제공됩니다.
(2) 회사가 제공하는 무료 체험 기간은 멤버십 회원의 실명을 기준으로 최초 가입 시에 1회만 제공되며, 이용계약을 해지한 후 재가입하였거나 제9조에 따라 이용이 제한된 회원에게는 무료 체험 기간을 제공하지 않습니다.

제 13 조 (서비스의 중단, 책임 제한 및 면책 등)
(1) 회사는 다음 각 호의 경우로 인하여 본 서비스를 제공할 수 없는 경우 본 서비스의 제공을 일시 중단할 수 있고, 본 서비스 제공에 관한 책임이 면제됩니다.
1. 통제할 수 없는 기술적 장애
2. 기간통신사업자, 본 서비스와 연관된 대행사, 제휴사에 불가피한 서비스 제공 제한 사항이 발생하는 경우 등 제3자의 귀책사유
3. 본 서비스용 설비의 보수 등 공사로 인한 부득이한 경우
4. 정전, 제반 설비의 장애 또는 이용량의 폭주 등으로 정상적인 서비스 이용에 지장이 있는 경우
5. 국가비상사태, 천재지변, 전염병의 창궐 또는 이에 준하는 불가항력적 사유
(2) 회사는 멤버십 회원의 귀책사유로 인한 본 서비스 이용의 장애에 대하여는 회사의 귀책사유가 없는 한 책임지지 않습니다.
(3) 회사는 멤버십 회원 상호간 또는 멤버십 회원과 제3자간에 본 서비스를 매개로 하여 발생한 분쟁 등에 대하여 회사의 귀책사유가 없는 한 책임지지 않습니다.

제 14 조 [서비스 종료]
회사가 본 서비스를 종료하고자 할 경우 회사는 종료일 30일전에 쇼핑몰에 서비스 종료 사실을 게시하고 제4조의 통지수단을 통하여 멤버십 회원에게 통지합니다. 이 경우 회사는 멤버십 회원이 서비스 종료일 전 마지막으로 결제한 이용기간에 대한 서비스 이용을 보장합니다. 단, 서비스 이용을 보장할 수 없는 경우 멤버십 회원이 지불한 이용료에서 실제 사용한 기간 등 멤버십 회원이 취득한 이익을 감안하고, 합리적인 범위 내에서 적용하는 소정의 기준율을 적용하여 차감한 후 환불합니다.

제 15 조 [멤버십 회원 개인정보의 제공]
(1) 회사는 본 서비스 제공을 위하여 필요한 범위 내에서 멤버십 회원의 최소한의 정보를 제휴사로부터 제공받거나, 제공할 수 있습니다.
(2) 회사와 제휴사간 개인정보 제공의 구체적인 내용은 본 서비스에 공지된 개인정보 제공 동의서에 기재되어 있으며, 회사는 회원의 이용신청 시 개인정보에 제공에 대한 회원의 동의를 얻어 이에 따라 멤버십 회원의 개인정보를 처리합니다.
(3) 개인정보 제공 동의서에서 규정하지 않은 사항은 회사의 개인정보 처리방침의 적용을 받습니다.
(4) 회사는 필요에 따라 개인정보 제공 동의서의 내용을 변경할 수 있으며, 이 경우 변경된 동의서의 내용에 대해 회원으로부터 별도로 동의를 받습니다.

제 16 조 [거래 정보의 제공 및 광고의 전송]
(1) 회사는 광고성 정보 수신에 동의한 멤버십 회원에 한하여, 멤버십 회원이 수집 및 이용에 동의한 개인정보를 활용하여 전자적 전송매체(SMS/MMS/e-mail 등 다양한 전송매체)를 통해 본 서비스 및 제 3자의 상품 또는 서비스에 대한 개인 맞춤형 광고 정보를 전송할 수 있습니다.
(2) 멤버십 회원은 법령에 따라 회사에게 부과된 의무이행을 위한 절차안내, 고객문의 등에 대한 답변, 기타 거래관련정보 등을 제외하고는 언제든지 전자우편 등에 대해서 수신 거절을 할 수 있습니다.

제 17 조 [약관의 해석, 준거법, 재판관할 등]
(1) 회사와 멤버십 회원 간에 본 약관의 해석에 대하여 이견이 있을 경우 회사와 멤버십 회원이 상호 협의하여 해결하거나 상관례에 따릅니다.
(2) 회사는 본 약관 외에 본 서비스에 관한 별도의 운영정책을 둘 수 있습니다.
(3) 본 약관에서 정하지 아니한 사항에 대하여는 「전자상거래 등에서의 소비자 보호에 관한 법률」, 「문화산업진흥 기본법」 등 관계 법령 및 쇼핑몰 이용약관, 운영정책, 이용안내의 내용을 따릅니다.
(4) 회사와 멤버십 회원 간에 발생한 분쟁에 대하여는 대한민국법을 준거법으로 합니다.
(5) 회사와 멤버십 회원 간에 발생한 분쟁에 관한 소송은 민사소송법상의 관할법원에 제소합니다.

부칙
1. 이 약관은 0000년 00월 00일부터 시행합니다.`,
    };
  },
  methods: {
    show: function(text) {
      if (text) {
        this.text = text;
      } else {
        this.text = this.sample_text;
      }
      this.membershipTermSettingModal = true;
    },
    save: async function() {
      let setParams = {
        use_terms: "enabled",
        terms_contents: this.text,
      };

      try {
        await M.api(M.entry("/put/membership/config"), setParams);
        alert("저장되었습니다.");
        this.membershipTermSettingModal = false;
        this.$parent.getMembershipConfigUseTerms(setParams);
      } catch (e) {
        alert("저장 실패했습니다.");
      }
    },
    sampleTermsApplication: function() {
      if (confirm("표본약관 내역을 입력 내역란에 적용하시겠습니까?")) {
        this.text = this.sample_text;
      }
    },
  },
};
</script>
